export default {"src":"/_next/static/media/card_bg_ressource.1ecac57a.svg","height":435,"width":1031};